import { gql } from '@apollo/client/core'
import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

import { EVENTS_FRAGMENT } from '@base/api/fragments/events'

export const EVENTS_QUERY = gql`
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}
  ${EVENTS_FRAGMENT}

  query getEvents($slug: String, $startDate: DateTime) {
    listEvents(
      filter: { clubSlug: $slug, dateStartAfter: $startDate }
      sort: [{ sortField: DISTANCE, sortOrder: ASC }]
      limit: 10
      offset: 0
    ) {
      ... on ListEventsOutput {
        events {
          ...Event
        }
      }
      ... on ListEventsErrorOutput {
        errors {
          name
          dateStartAfter
          dateStartBefore
          addressGeom
          sort
          limit
          offset
        }
      }
      ...UnauthorizedError
      ...UnauthenticatedError
      ...ServerError
    }
  }
`
